"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onEnded;
function onEnded(event) {
  // playingIndex is already updated so we want this to update
  if (this.playables.length === this.playingIndex + 1 || !this._autoAdvance) {
    this._playerState.goToStart = true;
    clearTimeout(this._timeUpdateInterval);

    // seek to end of clip duration (in case we stopped short a few ms)
    // then emit a timeupdate and pause the video
    if (event.internal) {
      this.currentTime = this.duration;
      this.emit('timeupdate');
      this.pause();
    }

    // We've ended now
    this.emit('ended', event);
    return;
  }

  // Sometimes THEO stops playing MP4s too soon and BasePlayer.js:L98 is not hit
  if (this.playables.length !== this.playingIndex && !this._playerState.paused && !this._transitionToNextClip) {
    this._transitionToNextClip = true;
    this._queueTransitionToNextClip();
  }
}